import React from 'react';
import { Link } from 'react-router-dom';
import { useMe } from '@/context/MeContext';
import { tActivity } from '@/i18n/activity';
import { activityViewAllPath } from '@/utils/activityNav';

export default function ActivityViewAllLink({ searchId }: { searchId?: string }) {
  const { me } = useMe();
  return (
    <Link
      to={activityViewAllPath(me, searchId)}
      className="btn btn-ghost btn-sm"
      data-testid="activity-view-all"
    >
      {tActivity('activity.viewAll')}
    </Link>
  );
}
